if (typeof L2H === 'undefined' || L2H === null) { window.L2H = {}; }

L2H.InternalTracker = class InternalTracker {
  constructor(permalink, source, rootURL) {
    this.permalink = permalink;
    this.source = source;
    this.rootURL = rootURL;
    this.trackerURL = `${this.rootURL}api/v1/stats/track`;
  }

  trackShopableClick(url, photoID, shopableID) {
    return this.track({
      type: "outbound",
      permalink: this.permalink,
      photo_id: photoID,
      url,
      source: this.source,
      shopable_id: shopableID
    });
  }

  trackModalView(photoID) {
    return this.track({
      type: "modal-view",
      permalink: this.permalink,
      photo_id: photoID,
      source: this.source
    });
  }

  trackPageView() {}
  // noop for now as this has
  // potential to cause way too much
  // traffic

  track(data) {
    const deferred = new $.Deferred();

    const timeoutID = setTimeout(function() {
      if (L2H.debug) { console.log("L2H DEBUG: resolving trackShoppableClick in timeout"); }
      return deferred.resolve();
    }
                                 , 1000);

    $.ajax({
      method: "GET",
      url: this.trackerURL,
      data,
      dataType: "jsonp"}).done(function(data) {
        // do nothing
      }).always(function() {
        window.clearTimeout(timeoutID);
        return deferred.resolve();
      });

    return deferred.promise();
  }
};
